import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 58
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="bg-blue-600 text-white py-1 px-3 text-center text-[11px] md:text-xs font-bold flex items-center justify-center gap-1.5 sticky top-0 z-50 shadow-sm" data-id="element-256">
      <Clock className="w-3 h-3" data-id="element-257" />
      <span className="tracking-tight" data-id="element-258">
        OFERTA EXPIRA EN: {formatTime(timeLeft.hours)}:
        {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)} | SOLO
        QUEDAN 3 CUPOS
      </span>
    </div>;
}